"use client"

import { useEffect } from "react"

const TKS_VERSION = "1.1.1"

export function VersionLog() {
    useEffect(() => {
        console.log(
            `%ctks v${TKS_VERSION} loaded`,
            "color: #7ed957; font-weight: bold; font-size: 14px;"
        )
    }, [])

    return null
}
